import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getTrialLessonList, trialLessonSelect } from 'redux-api/slices/trialLessonSlice';
import { homeSelect } from 'redux-api/slices/HomeSlice';
import { BITRIX, PATHS } from 'common/constants';
import teamPhoto from 'assets/image/home/hmTeamPhoto.webp';
import HomeButton from './HomeButton';
import HomeSectionHead from './HomeSectionHead';
import classes from './HomeTrial.module.scss';


// Бегущая строка: список дублируется, чтобы прокрутка была бесшовной.
const TagRow = ({ items, reverse }) => (
  <div className={`${classes.row} ${reverse ? classes.rowReverse : ''}`}>
    <div className={classes.track}>
      {[ 0, 1 ].map((copy) =>
        items.map((item, i) => (
          <a
            className={classes.tag}
            href={BITRIX.trialLesson}
            target="_blank"
            rel="nofollow noreferrer"
            key={`${copy}-${item?.text ?? i}`}
            aria-hidden={copy === 1 ? true : undefined}
            tabIndex={copy === 1 ? -1 : undefined}
          >
            {item?.text}
          </a>
        ))
      )}
    </div>
  </div>
);

// Запасные направления из макета — показываем, пока список не заполнен в админке.
const FALLBACK_TAGS = [
  'Frontend-разработка',
  'Менеджмент проектов',
  'Backend-разработка',
  'Основы программирования',
  'Мобильная разработка',
  'Программирование для детей',
  'IOS-разработка',
  'SMM менеджер',
  'Android-разработка',
  'Ux-Ui дизайнер',
  'Тестировщик ПО',
].map((text) => ({ text }));

const HomeTrial = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { trialLessonList } = useSelector(trialLessonSelect);
  const { centerPage = {} } = useSelector(homeSelect);

  const tags = trialLessonList.results?.length ? trialLessonList.results : FALLBACK_TAGS;
  const firstRow = tags.filter((_, i) => i % 2 === 0);
  const secondRow = tags.filter((_, i) => i % 2 === 1);

  useEffect(() => {
    dispatch(getTrialLessonList());
    return () => null;
  }, [ dispatch ]);

  return (
    <section className={classes.trial}>
      <div className={classes.container}>
        <HomeSectionHead
          title={t('TrialLesson')}
          action={<HomeButton to={PATHS.allcourses}>{t('AllCourses')}</HomeButton>}
        />
      </div>

      <div className={classes.media}>
        {!!tags.length && (
          <div className={classes.rows} data-aos="fade-up">
            <TagRow items={firstRow} />
            <TagRow items={secondRow} reverse />
          </div>
        )}

        {/* Фото берём из макета: картинка из админки слишком сжата для полной ширины. */}
        <div className={classes.image}>
          <img src={teamPhoto} alt={centerPage.top_image_alt || 'Команда Geeks'} loading="lazy" />
        </div>
      </div>
    </section>
  );
};

export default HomeTrial;
